import React from "react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../ui/accordion";
import { FAQS } from "../../data/faqs";

export default function FAQ() {
  return (
    <section id="faq" className="py-24 relative border-t border-white/10">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <div className="mb-10">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-neon-cyan mb-3">// frequently asked</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter">
            Questions, <span className="text-neon-cyan">answered.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-white/10">
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="text-base sm:text-lg font-semibold text-white hover:no-underline hover:text-neon-cyan py-5"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/60 leading-relaxed text-[15px]">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
